import { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { NavigateFunction } from 'react-router-dom';
import { APP_URLS } from '../../consts';

/* eslint-disable @typescript-eslint/ban-ts-comment */
const requestFullscreenAttribute = [
  'requestFullscreen',
  'mozRequestFullScreen',
  'webkitRequestFullscreen',
  'msRequestFullscreen',
  // @ts-ignore
].find((fnName) => typeof document.body?.[fnName] === 'function');

const closeFullscreenAttribute = [
  'exitFullscreen',
  'mozCancelFullScreen',
  'webkitExitFullscreen',
  'msExitFullscreen',
  // @ts-ignore
].find((fnName) => typeof document[fnName] === 'function');

export const requestFullscreen = (el: HTMLElement): Promise<void> => {
  if (!requestFullscreenAttribute) {
    return Promise.reject(new Error('Request fullscreen not supported for device'));
  }

  try {
    // @ts-ignore
    const promise = el[requestFullscreenAttribute]();

    if (promise) {
      return promise.catch((err: { name: string; message: string }) => {
        console.log(`An error occurred while trying to switch into fullscreen mode: ${err.message} (${err.name})`);
      });
    }

    return Promise.resolve();
  } catch (e) {
    return Promise.reject(e);
  }
};

export const getGameUrl = (gameUrl: string, playType?: 'demo' | 'real'): string => {
  return `/game-details/${gameUrl}${playType ? '#/' + playType : ''}`;
};

export const closeFullscreen = (): void => {
  // @ts-ignore
  if (closeFullscreenAttribute) document[closeFullscreenAttribute]();
};

export const isDocumentFullscreen = (): boolean =>
  ['fullscreenElement', 'mozFullScreenElement', 'webkitFullscreenElement', 'msFullscreenElement'].some(
    // @ts-ignore
    (att) => !!document[att]
  );

export const hasInPathName = (path: string): boolean => {
  return window.location.pathname.includes(path);
};

/**
 * Handle carousel navigation click as a separate route to navigate and expose selected category
 *
 * @param staticData
 * @param setters
 * @param hooks
 */
export const toggleCategoryNavigation = async (
  {
    gridMode,
    title,
    category,
    categorySlug,
  }: { gridMode: boolean; title?: string; category?: string; categorySlug?: string },
  {
    setGridMode,
    setSelectedCategory,
  }: { setGridMode: (arg: boolean) => void; setSelectedCategory: (arg: string) => UnknownAction },
  { dispatch, navigate }: { dispatch: Dispatch; navigate: NavigateFunction }
): Promise<void> => {
  if (gridMode) {
    await navigate(`${APP_URLS.gameLobby.main}/${category}`);
    dispatch(setSelectedCategory(''));
  } else {
    await navigate(`${APP_URLS.gameLobby.main}/${category}/${categorySlug}`);
    dispatch(setSelectedCategory(title || ''));
  }

  setGridMode(!gridMode);
};
